// AUTO-GENERATED by shared/generators/config_enums_generator.py — do not edit.
// WorkItemType — source: shared/config/sf_item_types.config.json

export const WORK_ITEM_TYPE_VALUES = ["idea", "feature", "bug", "tech_debt", "enhancement", "test", "data", "site_reliability", "integration"] as const;
export type WorkItemType = (typeof WORK_ITEM_TYPE_VALUES)[number];

export const workItemTypeBadgeClass: Record<WorkItemType, string> = {
  "idea": "bg-purple-100 text-purple-800 dark:bg-purple-900/30 dark:text-purple-400",
  "feature": "bg-blue-100 text-blue-800 dark:bg-blue-900/30 dark:text-blue-400",
  "bug": "bg-red-100 text-red-800 dark:bg-red-900/30 dark:text-red-400",
  "tech_debt": "bg-yellow-100 text-yellow-800 dark:bg-yellow-900/30 dark:text-yellow-400",
  "enhancement": "bg-green-100 text-green-800 dark:bg-green-900/30 dark:text-green-400",
  "test": "bg-cyan-100 text-cyan-800 dark:bg-cyan-900/30 dark:text-cyan-400",
  "data": "bg-pink-100 text-pink-800 dark:bg-pink-900/30 dark:text-pink-400",
  "site_reliability": "bg-lime-100 text-lime-800 dark:bg-lime-900/30 dark:text-lime-400",
  "integration": "bg-orange-100 text-orange-800 dark:bg-orange-900/30 dark:text-orange-400",
};

export const workItemTypeColor: Record<WorkItemType, string> = {
  "idea": "#8B5CF6",
  "feature": "#3B82F6",
  "bug": "#EF4444",
  "tech_debt": "#F59E0B",
  "enhancement": "#10B981",
  "test": "#06B6D4",
  "data": "#EC4899",
  "site_reliability": "#84CC16",
  "integration": "#F97316",
};

export const workItemTypeIcon: Record<WorkItemType, string> = {
  "idea": "Lightbulb",
  "feature": "Sparkles",
  "bug": "Bug",
  "tech_debt": "Wrench",
  "enhancement": "ArrowUp",
  "test": "FlaskConical",
  "data": "Database",
  "site_reliability": "Activity",
  "integration": "Plug",
};

